import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import ServiceLayout from './layout/ServiceLayout';

import Dashboard from './Dashboard';
import Profile from './Profile';
import Packages from './Packages';
import Picha from './Picha';
import Reviews from './Reviews';

const WatoaHudumaRoutes = () => {
  return (
    <Routes>
      <Route element={<ServiceLayout />}>
        <Route index element={<Profile />} />
        <Route path="profile" element={<Profile />} />
        <Route path="packages" element={<Packages />} />
        <Route path="picha" element={<Picha />} />
        <Route path="reviews" element={<Reviews />} />
      </Route>
    </Routes>
  );
};

export default WatoaHudumaRoutes;